<template>
  <div @click="itemClicked(item)" style="cursor: pointer;">
    <div v-if="item.regtype === item[header.value]">
      <div>
        <b>{{ header.text }}</b>
      </div>
      <div>
        <slot name="procColor"></slot>
      </div>
    </div>

    <div
      v-if="
        item.officer === item[header.value] || item.fqdn === item[header.value]
      "
    >
      <div>
        <div>
          <b>{{ header.text }}</b>
        </div>
        <div>{{ item[header.value] }}</div>
      </div>
    </div>

    <div v-if="item.creationdate === item[header.value]">
      <div>
        <b>{{ header.text }}</b>
      </div>
      <div>
        <slot name="createDate"></slot>
      </div>
    </div>

    <div v-if="item.status === item[header.value]">
      <div>
        <b>{{ header.text }}</b>
      </div>
      <div>
        <slot name="statusCol"></slot>
      </div>
    </div>

    <div v-if="item.validity === item[header.value]">
      <div>
        <div>
          <b>{{ header.text }}</b>
        </div>
        <div v-if="item.status === 'open' || item.status === 'closed'">
          {{ item[header.value] }}
        </div>
        <div class="mb-2" v-if="item.status === 'closed'"></div>
      </div>
    </div>

    <div v-if="item.actions === item[header.value]">
      <div>
        <v-menu offset-y style="width: 100%;">
          <template v-slot:activator="{ attrs, on }">
            <transition name="bounce" mode="out-in">
              <v-icon medium v-bind="attrs" v-on="on" class="mr-2"
                >fa-light fa-ellipsis-vertical</v-icon
              >
            </transition>
          </template>
          <v-list>
            <v-list-item
              class="mb-2 mb-md-0"
              v-if="item.status === 'open' && hasRoles(constants.UPDATE_REGISTRATION_ROLES)"
              @click.stop="dialog = true"
              @click="openActionStatus(item)"
            >
              <i class="mr-2 fa-light fa-toggle-off fa-2xl"></i>
              Change Status to Closed
            </v-list-item>
            <v-list-item
              class="mb-2 mb-md-0"
              v-if="item.status === 'closed' && hasRoles(constants.UPDATE_REGISTRATION_ROLES)"
              @click.stop="dialog = true"
              @click="openActionStatus(item)"
            >
              <i class="mr-2 fa-light fa-toggle-on fa-2xl"></i>
              Change status to Open
            </v-list-item>
            <v-list-item
              v-if="hasRoles(constants.UPDATE_REGISTRATION_ROLES)"
              @click.stop="dialogPass = true"
              @click="openActionPassword(item)"
            >
              <i class="mr-2 fa-light fa-key fa-xl"></i>
              Change Password
            </v-list-item
            >
          </v-list>
        </v-menu>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import * as constants from "@/config/constants";

export default {
  props: ["item", "header"],
  data() {
    return {};
  },
  computed: {
    constants() {
      return constants
    },
    ...mapGetters(["getRoles"])
  },
  methods:{
    hasRoles(roles) {
      return roles.every((role) => this.getRoles.includes(role));
    },
    itemClicked(val){
      this.$emit("itemClicked",val)
    },
    openActionStatus(val){
      loggg("Something")
      loggg(val)
      this.$emit("openActionStatus",val)
    },
    openActionPassword(val){
      this.$emit("openActionPassword",val)
    }

  },
};
</script>
<style></style>
